var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupTwoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000160217 14.3421V8.75338C-0.000160217 7.83418 0.730433 7.09883 1.64367 7.09883H3.68934L3.79893 6.2164C2.55692 5.70165 1.68021 4.41478 1.82632 2.94407C1.97244 1.36305 3.28751 0.076178 4.85829 0.00264237C6.7213 -0.0708932 8.25555 1.39982 8.25555 3.23821C8.25555 4.56185 7.45189 5.73842 6.28294 6.2164L6.39253 7.09883H8.4382C9.35144 7.09883 10.082 7.83418 10.082 8.75338V14.3421C10.082 14.4892 9.97244 14.6362 9.78979 14.6362H0.292076C0.145958 14.6362 -0.000160217 14.5259 -0.000160217 14.3421ZM9.7169 3.86339C9.60731 5.00319 10.2648 5.99592 11.2146 6.40037L11.105 7.09896H10.1187C10.5571 7.5034 10.8128 8.09169 10.8128 8.75351V13.7172H15.7808C15.8904 13.7172 16 13.6069 16 13.4966V8.34906C16 7.61371 15.4155 7.06219 14.7215 7.06219H13.1507L13.0776 6.3636C13.9909 5.99592 14.6119 5.1135 14.6119 4.084C14.6119 2.68682 13.4429 1.54702 12.0183 1.62056C10.8128 1.69409 9.82648 2.65006 9.7169 3.86339Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTwoIcon);
export default ForwardRef;